import { useParams } from 'react-router-dom'

import { useUserInfoStore } from '@/stores/user/userInfoStore'
import { hasRoleFromGroup } from '@/utils/auth/roleGroups'

export const useContractsAccess = () => {
  const selectedOrganisation = useUserInfoStore(
    (state) => state.selectedOrganisation
  )
  const organisation = useUserInfoStore((state) => state.organisation)
  const canEdit = useUserInfoStore((state) =>
    hasRoleFromGroup(state.tokenRoles, 'SUPPLIER_STAFF')
  )
  const { code } = useParams()

  const isSelectedOrganisation =
    Object.keys(selectedOrganisation).length > 0 &&
    Number(code) == selectedOrganisation.code
  const org = isSelectedOrganisation ? selectedOrganisation : organisation

  return { organisationId: org.id, isSelectedOrganisation, canEdit }
}
